import React from "react";

export default function ConfirmModal({
  open,
  title = "Please confirm",
  message = "",
  confirmText = "Confirm",
  cancelText = "Cancel",
  loading = false,
  onCancel,
  onConfirm,
}) {
  if (!open) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h3 style={{ marginTop: 0 }}>{title}</h3>
        <p style={{ marginTop: 8, color: "#475569" }}>{message}</p>
        <div style={styles.row}>
          <button type="button" onClick={onCancel} style={styles.cancelBtn} disabled={loading}>
            {cancelText}
          </button>
          <button type="button" onClick={onConfirm} style={styles.confirmBtn} disabled={loading}>
            {loading ? "Please wait..." : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(15, 23, 42, 0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    padding: "1rem",
  },
  modal: {
    width: "100%",
    maxWidth: 480,
    background: "#fff",
    borderRadius: 14,
    border: "1px solid #e2e8f0",
    boxShadow: "0 20px 50px rgba(2, 6, 23, 0.25)",
    padding: "1.25rem",
  },
  row: {
    marginTop: 16,
    display: "flex",
    justifyContent: "flex-end",
    gap: 10,
  },
  cancelBtn: {
    border: "1px solid #cbd5e1",
    background: "#fff",
    color: "#0f172a",
    borderRadius: 10,
    padding: "0.55rem 0.95rem",
    cursor: "pointer",
    fontWeight: 600,
  },
  confirmBtn: {
    border: "none",
    background: "linear-gradient(90deg,#f43f5e,#fb7185)",
    color: "#fff",
    borderRadius: 10,
    padding: "0.55rem 1rem",
    cursor: "pointer",
    fontWeight: 700,
  },
};
